import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09b392b4&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=09b392b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b392b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b392b4')) {
      api.createRecord('09b392b4', component.options)
    } else {
      api.reload('09b392b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=09b392b4&scoped=true&", function () {
      api.rerender('09b392b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_Loaders/index.vue"
export default component.exports